<template>
<div class="chapter">
<div class="inner_page">
<p class="head">CONTENTS</p>
<p class="toc"><a href="#/Text/ack">Acknowledgements</a></p>
<p class="toc"><a href="#/Text/intro">Introduction</a></p>
<p class="toc1"><a href="#/Text/cha1">1. Early Barns: Traditional Structures Before the Civil War</a></p>
<p class="toc"><span href="#/Text/cha2" title="Link target outside of Sample">2. The Old Majestics: Big Haylofts and Fancy Cupolas</span></p>
<p class="toc"><span href="#/Text/cha3" title="Link target outside of Sample">3. Our Barns: Assorted Barns, Assorted People</span></p>
<p class="toc"><span href="#/Text/cha4" title="Link target outside of Sample">4. Up North and Down East: The Border Barns of Aroostook and Washington Counties</span></p>
<p class="toc"><span href="#/Text/cha5" title="Link target outside of Sample">5. Surviving in the South: The Barns of York and Cumberland County Farmers</span></p>
<p class="toc"><span href="#/Text/cha6" title="Link target outside of Sample">6. The Restorers: Resurrecting Our Barns</span></p>
<p class="toc1"><span href="#/Text/con1" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc"><span href="#/Text/glo" title="Link target outside of Sample">Glossary of Barn-Related Terms: What You Need to Know from A to Z</span></p>
<p class="toc"><span href="#/Text/dia" title="Link target outside of Sample">Diagrams and Drawings: A Visual Perspective</span></p>
<p class="toc"><span href="#/Text/abt" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?2685eb40